(ns com.theplantscape.web-ui.tailwind.form.elements.checkbox
  (:require [reagent.core :as r]))

(defn ui-form-boolean [value-atom {:keys [name label placeholder tooltip default] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip default] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       #_(when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
       [:label.font-semibold.text-sm.text-gray-600.pb-1 label]
       [:input.block.p-8.mt-4.mb-4
        (->
         {:type "checkbox"
          :default-value @value-atom
          :value @value-atom
          :placeholder placeholder
          :name name
          :on-focus #(reset! focused true)
          :on-blur #(reset! focused false)
          :on-change (fn [e]
                       (if (-> e .-target .-checked)
                         (reset! value-atom true)
                         (reset! value-atom false)))}
         (conj (when (boolean @value-atom) [:checked "checked"])))]])))

(defn ui-form-checkbox [value-atom {:keys [name label placeholder tooltip default] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip default] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.inline-block.font-medium.text-sm.text-gray-600.py-2 label])
       [:input.block.p-8.mt-4.mb-4
        (->
         {:type "checkbox"
          :default-value @value-atom
          :value @value-atom
          :placeholder placeholder
          :name name
          :on-focus #(reset! focused true)
          :on-blur #(reset! focused false)
          :on-change (fn [e]
                       (if (-> e .-target .-checked)
                         (reset! value-atom default)
                         (reset! value-atom nil))
                       #_((:store-fn attrib) e))}
         (conj (when (boolean @value-atom) [:checked "checked"])))]])))


(defn ui-form-checkbox-fn [{:keys [name label placeholder tooltip default set-value get-value] :as attrib}]
  (let [focused (r/atom false)]
    (fn [{:keys [name label placeholder tooltip default] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.inline-block.font-medium.text-sm.text-gray-600.py-2 label])
       [:input.block.p-8.mt-3.mb-4.mr-4.float-left
        (->
         {:type "checkbox"
          :default-value default ;@value-atom 
          ;:value @value-atom
          :placeholder placeholder
          :name name
          :on-focus #(reset! focused true)
          :on-blur #(reset! focused false)
          :on-change #(set-value (keyword name) %)
          #_(fn [e]
                       (when set-value 
                         (set-value
                          (keyword name)
                          (if (-> e .-target .-checked) default nil))))}
         (conj (when (and get-value (boolean (get-value (keyword name)) #_@value-atom)) [:checked "checked"])))]])))
